import React from 'react';
import HeaderSortCell from './HeaderSortCell';
import DataCell from './DataCell';

export const renderCell = props => {
  const { hoveredRowId, componentMap, setHoveredRowId, handleSort, sortConfig, isHeaderCell, column, row } = props;

  if (isHeaderCell) {
    return (
      <HeaderSortCell componentMap={componentMap} isHeaderCell={isHeaderCell} column={column} handleSort={handleSort} sortConfig={sortConfig} />
    );
  }

  return <DataCell componentMap={componentMap} row={row} column={column} setHoveredRowId={setHoveredRowId} hoveredRowId={hoveredRowId} />;
};
